module.exports = __webpack_public_path__ + "static/TiemposFineWeb-Semibold-e41b175fb36978412d11817927578bee.woff";